export default __webpack_public_path__ + "static/media/discord.5276e84b.svg";